import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Service} from '../../components/index';
import Imgage1 from '../../assets/img/planet-explorers-services.jpg';
import Imgage2 from '../../assets/img/planet-events-general.jpg';
import Imgage3 from '../../assets/img/planet-in.jpg';
import {get} from '../../redux/modules/services';

class Services extends PureComponent {

  componentWillMount() {
    this.props.getAction();
  }

  render() {
    const {services: {values: {text, services = []}, isFetching}} = this.props;

    if (isFetching) {
      return <div/>
    }

    return (
      <div className="main container">
        <div className="services">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div dangerouslySetInnerHTML={{__html: text.body}}/>
            </div>
          </div>
          <div className="row">
            {
              services.map((services) => {
                return (
                  <div key={services.id} className="col-md-4 col-sm-6 services-item">
                    <Service {...services}/>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      services: state.services
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(Services);




// WEBPACK FOOTER //
// ./src/containers/services/Services.js